const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

export function isEmail (s: string) {
  return emailRegex.test(s?.toLowerCase())
}

export function ucFirst (string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function replaceUmlauts (string: string) {
  return string
    .replace(/\u00df/g, 'ss')
    .replace(/\u00e4/g, 'ae')
    .replace(/\u00f6/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\u00c4/g, 'Ae')
    .replace(/\u00d6/g, 'Oe')
    .replace(/\u00dc/g, 'Ue')
}

export function cleanUpSearchPhrase (phrase: string): string {
  return phrase
    .replace(/\p{Extended_Pictographic}/gu, '') // remove emojis and pictos
    // eslint-disable-next-line no-control-regex
    .replace(/[\x00-\x08\x0B-\x1F\x7F]/g, '') // remove control characters
    .trim().replace(/\s+/g, ' ') // remove extra spaces
    .replace(/([+\-=&|><!(){}[\]^"~*?:\\/])/g, '\\$1') // escape ES special characters
}

// Algorithmus-Prinzip (DJB2)
export function hashString (str: string): string {
  let hash = 5381 // seed value
  // Iterate over each character in the string
  for (let i = 0; i < str.length; i++) {
    // Update the hash value using bitwise operations
    hash = (hash * 33) ^ str.charCodeAt(i)
  }
  // Converts the hash to an 8-character hex string
  return (hash >>> 0).toString(16).padStart(8, '0')
}

// 64-bit hash using two DJB2 hashes with different seeds
export function hashString64 (str: string): string {
  let hash1 = 5381
  let hash2 = 52711 // different seed for second hash

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash1 = (hash1 * 33) ^ char
    hash2 = (hash2 * 33) ^ char
  }

  // Combine into 16-character hex string (8 bytes)
  const high = (hash1 >>> 0).toString(16).padStart(8, '0')
  const low = (hash2 >>> 0).toString(16).padStart(8, '0')
  return high + low
}
